import React, { Fragment, useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import ButtonMui from "@mui/material/Button";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ServiciosContext } from "../../context/ServiciosContext";

const preguntas = [
  "¿Cuál diría que fue el motivo por el cual ingresó a la residencia?",
  "¿Qué espera de su estadía en la residencia?",
  "¿Cuáles son los problemas relacionados a su salud en los que le interesaría recibir apoyo por parte del equipo de la residencia?",
  "¿Existe algún problema o situación que incida en su estado de ánimo y/o comportamiento en el que le gustaría recibir apoyo?",
  "¿Existe alguna situación que le provoque temor o preocupación respecto a su llegada y permanencia en la residencia?",
  "De todas las preguntas realizadas, ¿cuál de todas ellas es la que más le interesa?",
  "De acuerdo a las expectativas mencionadas anteriormente respecto a la residencia, ¿cuáles cree que se han cumplido? ¿Por qué? ¿Qué espera de esta nueva etapa?",
  "Respecto a lo que esperaba de sus amistades, su participación y relación con otros durante su permanencia en la residencia, ¿qué aspectos cree que se han cumplido? ¿Por qué? ¿Qué espera de esta nueva etapa?",
  "De acuerdo a sus expectativas en relación a los problemas de salud, ¿cuáles cree que se han cumplido?",
  "De acuerdo a los temores y preocupaciones que presentaba respecto a su estadía en la residencia, ¿estas situaciones se produjeron? Si es así, ¿por qué cree que se produjeron? Para esta nueva etapa, ¿existe alguna situación que le provoque temor o le preocupe?",
  "Respecto a las situaciones que mencionó que influían en su estado de ánimo y/o su comportamiento, durante este período en la residencia, ¿hubo situaciones que influenciaron en su estado de ánimo y/o su comportamiento? Si es así, ¿le gustaría hablar de ellas?",
  "Respecto a todas las expectativas conversadas en esta evaluación, ¿cuál de todas ellas es la que más le interesa abordar?",
];

const puntos = {
  familia: ["familiaX", "familiaY"],
  amigos: ["amigosX", "amigosY"],
  relacionesLaborales: ["relacionesLaboralesX", "relacionesLaboralesY"],
  relacionesComunitarias: [
    "relacionesComunitariasX",
    "relacionesComunitariasY",
  ],
};

const crearValoracionVacia = (pacienteId) => ({
  pacienteId,
  fecha: new Date().toISOString().slice(0, 10),
  familiaX: null,
  familiaY: null,
  amigosX: null,
  amigosY: null,
  relacionesLaboralesX: null,
  relacionesLaboralesY: null,
  relacionesComunitariasX: null,
  relacionesComunitariasY: null,
  aspectosConsiderar: "",
  pregunta1: "",
  pregunta2: "",
  pregunta3: "",
  pregunta4: "",
  pregunta5: "",
  pregunta6: "",
  pregunta7: "",
  pregunta8: "",
  pregunta9: "",
  pregunta10: "",
  pregunta11: "",
  pregunta12: "",
  diagnostico: "",
  observaciones: "",
});

export default function ValoracionSocial() {
  const centroX = 260;
  const centroY = 210;
  const radio = 140;
  const {
    selectedRowPaciente,
    frasesSociales,
    valoracionSocial,
    setValoracionSocial,
    obtenerFrasesSociales,
    obtenerValoracionSocial,
  } = useContext(ServiciosContext);
  const [formulario, setFormulario] = useState(
    crearValoracionVacia(selectedRowPaciente ? selectedRowPaciente.id : null),
  );
  const [dialogFrases, setDialogFrases] = useState(false);
  const [campoFrases, setCampoFrases] = useState(null);
  const [tipoFrases, setTipoFrases] = useState(null);

  useEffect(() => {
    if (selectedRowPaciente) {
      obtenerFrasesSociales({});

      if (
        valoracionSocial &&
        Number(valoracionSocial.pacienteId) === Number(selectedRowPaciente.id)
      ) {
        setFormulario({
          ...crearValoracionVacia(selectedRowPaciente.id),
          ...valoracionSocial,
        });
      } else {
        setValoracionSocial(null);
        setFormulario(crearValoracionVacia(selectedRowPaciente.id));
        obtenerValoracionSocial({ pacienteId: selectedRowPaciente.id });
      }
    }
    // Las acciones del contexto no son referencias estables y provocarían recargas continuas.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowPaciente]);

  useEffect(() => {
    if (valoracionSocial && selectedRowPaciente) {
      setFormulario({
        ...crearValoracionVacia(selectedRowPaciente.id),
        ...valoracionSocial,
        fecha: valoracionSocial.fecha
          ? valoracionSocial.fecha.slice(0, 10)
          : new Date().toISOString().slice(0, 10),
      });
    }
  }, [valoracionSocial, selectedRowPaciente]);

  const actualizarCampo = (campo, valor) => {
    setFormulario((actual) => {
      const actualizado = { ...actual, [campo]: valor };
      setValoracionSocial(actualizado);
      return actualizado;
    });
  };
  const frasesDe = (tipo) =>
    frasesSociales
      ? frasesSociales.filter((item) => item.tipo === tipo)
      : [];

  const insertarFrase = (campo, frase) => {
    if (!frase) return;
    setFormulario((actual) => {
      const actualizado = {
        ...actual,
        [campo]: actual[campo] ? `${actual[campo]}\n${frase}` : frase,
      };
      setValoracionSocial(actualizado);
      return actualizado;
    });
  };

  const abrirFrases = (campo, tipo) => {
    setCampoFrases(campo);
    setTipoFrases(tipo);
    setDialogFrases(true);
  };

  const seleccionarFrase = (frase) => {
    insertarFrase(campoFrases, frase);
    setDialogFrases(false);
  };
  const ubicarPunto = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 520;
    const y = ((e.clientY - rect.top) / rect.height) * 440;
    const relativoX = x - centroX;
    const relativoY = y - centroY;

    if (Math.sqrt(relativoX ** 2 + relativoY ** 2) > radio) return;

    let cuadrante;
    if (relativoX < 0 && relativoY < 0) cuadrante = "familia";
    if (relativoX >= 0 && relativoY < 0) cuadrante = "amigos";
    if (relativoX < 0 && relativoY >= 0) cuadrante = "relacionesLaborales";
    if (relativoX >= 0 && relativoY >= 0)
      cuadrante = "relacionesComunitarias";

    const [campoX, campoY] = puntos[cuadrante];
    setFormulario((actual) => {
      const actualizado = {
        ...actual,
        [campoX]: Number((relativoX / radio).toFixed(4)),
        [campoY]: Number((relativoY / radio).toFixed(4)),
      };
      setValoracionSocial(actualizado);
      return actualizado;
    });
  };

  const renderPunto = (nombre, color) => {
    const [campoX, campoY] = puntos[nombre];
    if (formulario[campoX] === null || formulario[campoY] === null) return null;

    return (
      <circle
        cx={centroX + formulario[campoX] * radio}
        cy={centroY + formulario[campoY] * radio}
        r="7"
        fill={color}
        stroke="#ffffff"
        strokeWidth="2"
        pointerEvents="none"
      />
    );
  };

  if (!selectedRowPaciente) return null;

  return (
    <Grid container spacing={3} style={{ padding: "1rem" }}>
      <Grid item xs={12}>
        <Typography variant="h5">Valoración Social</Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Mapeo de redes</Typography>
        <Typography variant="body2">
          Haga clic dentro de cada cuadrante para ubicar su punto.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div style={{ width: "100%", maxWidth: "720px", margin: "0 auto" }}>
          <svg
            viewBox="0 0 520 440"
            role="img"
            aria-label="Mapa interactivo de redes sociales"
            onClick={ubicarPunto}
            style={{ width: "100%", cursor: "crosshair", display: "block" }}
          >
            <rect width="520" height="440" fill="#ffffff" />
            {[radio / 3, (radio * 2) / 3, radio].map((r, index) => (
              <circle
                key={r}
                cx={centroX}
                cy={centroY}
                r={r}
                fill="none"
                stroke="#667085"
                strokeWidth="2"
              />
            ))}
            <line x1={centroX - radio} y1={centroY} x2={centroX + radio} y2={centroY} stroke="#344054" strokeWidth="2" />
            <line x1={centroX} y1={centroY - radio} x2={centroX} y2={centroY + radio} stroke="#344054" strokeWidth="2" />
            <text x="145" y="40" textAnchor="middle" fontSize="17">Familia</text>
            <text x="375" y="40" textAnchor="middle" fontSize="17">Amigos</text>
            <text x="140" y="395" textAnchor="middle" fontSize="16">Relaciones laborales</text>
            <text x="385" y="395" textAnchor="middle" fontSize="16">Relaciones comunitarias</text>
            <text x={centroX - 12} y={centroY - radio / 3 + 4} textAnchor="end" fontSize="14">1</text>
            <text x={centroX - 12} y={centroY - (radio * 2) / 3 + 4} textAnchor="end" fontSize="14">2</text>
            <text x={centroX - 12} y={centroY - radio + 4} textAnchor="end" fontSize="14">3</text>
            {renderPunto("familia", "#d92d20")}
            {renderPunto("amigos", "#175cd3")}
            {renderPunto("relacionesLaborales", "#027a48")}
            {renderPunto("relacionesComunitarias", "#b54708")}
          </svg>
        </div>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Aspectos a considerar</Typography>
      </Grid>
      <Grid item xs={10} sm={11}>
        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Texto"
          value={formulario.aspectosConsiderar || ""}
          onChange={(e) => actualizarCampo("aspectosConsiderar", e.target.value)}
        />
      </Grid>
      <Grid item xs={2} sm={1}>
        <Button
          icon="pi pi-align-justify"
          tooltip="Frases"
          className="p-button-rounded p-button-help"
          onClick={() =>
            abrirFrases("aspectosConsiderar", "Aspectos a considerar")
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Cuestionario de expectativas</Typography>
      </Grid>
      {preguntas.map((pregunta, index) => {
        const numero = index + 1;
        const campo = `pregunta${numero}`;
        return (
          <Fragment key={campo}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">
                {numero}. {pregunta}
              </Typography>
            </Grid>
            <Grid item xs={10} sm={11}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Respuesta"
                value={formulario[campo] || ""}
                onChange={(e) => actualizarCampo(campo, e.target.value)}
              />
            </Grid>
            <Grid item xs={2} sm={1}>
              <Button
                icon="pi pi-align-justify"
                tooltip="Frases"
                className="p-button-rounded p-button-help"
                onClick={() => abrirFrases(campo, `Pregunta ${numero}`)}
              />
            </Grid>
          </Fragment>
        );
      })}

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={5}
          label="Diagnóstico"
          value={formulario.diagnostico || ""}
          onChange={(e) => actualizarCampo("diagnostico", e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Observaciones"
          value={formulario.observaciones || ""}
          onChange={(e) => actualizarCampo("observaciones", e.target.value)}
        />
      </Grid>
      <Dialog
        header={tipoFrases || "Frases"}
        visible={dialogFrases}
        onHide={() => setDialogFrases(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "45rem", maxWidth: "95vw" }}
        position="top"
      >
        {frasesDe(tipoFrases).length > 0 ? (
          frasesDe(tipoFrases).map((item) => (
            <div key={item.id} style={{ borderBottom: "1px solid #d9d9d9" }}>
              <ButtonMui
                fullWidth
                onClick={() => seleccionarFrase(item.frase)}
                style={{
                  justifyContent: "flex-start",
                  textAlign: "left",
                  padding: "0.75rem",
                }}
              >
                {item.frase}
              </ButtonMui>
            </div>
          ))
        ) : (
          <Typography variant="body2">No hay frases cargadas.</Typography>
        )}
      </Dialog>
    </Grid>
  );
}
